/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Chip_MiniappInputs */

const vi_shop_home_chip_miniapp = /** @type {(inputs: Shop_Home_Chip_MiniappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mini App`)
};

/**

* @param {Shop_Home_Chip_MiniappInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_chip_miniapp = /** @type {((inputs?: Shop_Home_Chip_MiniappInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Chip_MiniappInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_chip_miniapp(inputs)
});